import {
    createStyles,
    Paper,
    Theme,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import React, { useEffect } from "react";
import Constants from "../../models/utility/Constants";
import { useGetConfigQuery } from "../../api/configApiSlice";

const WhiteTextTypography = withStyles({
    root: {
        color: "#FFFFFF"
    }
})(Typography) as typeof Typography;

const styles = (theme: Theme) =>
    createStyles({
        button: { marginTop: theme.spacing(3) },
        divider: {
            marginBottom: theme.spacing(4),
            marginTop: theme.spacing(4)
        },
        forgotLink: {
            cursor: "pointer",
            display: "block",
            marginTop: theme.spacing(2)
        },
        form: {
            maxWidth: 650,
            padding: theme.spacing(8),
            width: "100%"
        },
        formFieldTop: { marginTop: 0 },
        paper: {
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#231F20"
        },
        content: {
            width: "100%"
        },
        header: {
            width: "100%",
            height: "320px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            backgroundPosition: "top",
            backgroundSize: "cover",
            background: "url(/assets/404_banner.jpg)"
        },
        headline: {
            color: "white",
            fontSize: "2.25rem"
        },
        section: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "2rem",

            "& p": {
                margin: "2rem"
            },

            "& a": {
                fontWeight: "bold"
            }
        }
    });

type INotFoundProps = WithStyles<typeof styles>;

function NotFound({ classes }: INotFoundProps) {
    useEffect(() => {
        Constants.SetDocumentTitle("404: Page Not Found");
    }, []);

    const getConfigQuery = useGetConfigQuery();

    return (
        <Paper className={classes.paper} elevation={2}>
            <main className={classes.content}>
                <div className={classes.header}>
                    <Typography variant="h5" className={classes.headline}>
                        Page Not Found
                    </Typography>
                </div>
                <section className={classes.section}>
                    <div>
                        <WhiteTextTypography variant="body2">
                            We're sorry, but the page that you're looking for
                            has either been removed or relocated.
                        </WhiteTextTypography>
                        <WhiteTextTypography variant="body2">
                            You can return to our{" "}
                            <a
                                className="text-clhbid-orange"
                                href={getConfigQuery?.data?.salesPageUrl}
                            >
                                homepage
                            </a>{" "}
                            or, if you can't find what you're looking for,
                            please feel free to{" "}
                            <a
                                className="text-clhbid-orange"
                                href={
                                    getConfigQuery?.data?.salesPageUrl +
                                    "/contact"
                                }
                            >
                                contact us
                            </a>
                            .
                        </WhiteTextTypography>
                    </div>
                </section>
            </main>
        </Paper>
    );
}

export default withStyles(styles)(NotFound);
